import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import numbro from 'numbro';
import moment from 'moment';
import PanelLoading from '../../components/panelLoading';
import Loading from '../../components/loading';
import { fetchVipInfo, activeVip, checkVipPreliminary } from '../../reducer/vip';
import {
    VIP_NAME,
    VIP_PRELIMINARY,
    VIP_IMG,
    PROFILE_URL,
    BINDING_URL,
    PB_EXCHSNGE_GUIDE,
    VIP_FEEDBACK_RATE,
    VIP_COLOR
} from '../../constants';

function LoadUserInfo() {
    return (
        <div className="panel panel-default">
            <div className="panel-heading">載入中…</div>
            <div className="panel-body" style={{ position: 'relative' }}>
                <PanelLoading />
            </div>
        </div>
    );
}

class VipProgress extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            amount: 1
        };
    }
    componentWillUnmount() {
        if (this.handler) {
            clearInterval(this.handler);
        }
    }
    componentDidMount() {
        const { vipCardLevel, orderAmount } = this.props.userInfo;
        const nextVipLevel = vipCardLevel + 1;
        const nextVip = VIP_PRELIMINARY[nextVipLevel];
        const nextPercent = Math.min(Math.round(orderAmount / nextVip * 100), 99);
        const step = Math.round(nextVip / 6);
        setTimeout(() => {
            this.setState({ value: nextPercent });
        }, 200);
        this.handler = setInterval(() => {
            this.setState((preState) => {
                const nextAmount = Math.min(preState.amount + step, orderAmount);
                if (nextAmount === orderAmount) {
                    clearInterval(this.handler);
                }
                return { amount: nextAmount };
            });
        }, 100);
    }
    render() {
        const { vipCardLevel } = this.props.userInfo;
        const { value, amount } = this.state;
        const nextVipLevel = vipCardLevel + 1;
        const nextVip = VIP_PRELIMINARY[nextVipLevel];
        const nextDist = nextVip - amount;
        return (
            <div>
                <hr />
                目前累計儲值金額為 {numbro(amount).format('0,0')} 元，
                距離升級 {VIP_NAME[nextVipLevel]} 還差 {numbro(nextDist).format('0,0')} 元
                <div className="progress">
                    <div
                        className="progress-bar progress-bar-success progress-bar-striped active"
                        role="progressbar"
                        aria-valuenow={value}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{ width: `${value}%`, minWidth: '2em', backgroundColor: VIP_COLOR[vipCardLevel] }}>
                        {value}%
                        <span className="sr-only">{value}% Complete</span>
                    </div>
                </div>
            </div>
        );
    }
}

function MyVip(props) {
    const { vipCardLevel, startTime, endTime } = props.userInfo;
    const feedbackRate = numbro(VIP_FEEDBACK_RATE[vipCardLevel]).format('0%');
    return (
        <div className="panel panel-default">
            <div className="panel-heading">目前卡別</div>
            <div className="panel-body">
                <div className="media">
                    <div className="media-left media-middle">
                        <img style={{ width: '150px' }} alt={VIP_NAME[vipCardLevel]} className="media-object"
                            src={`https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/${VIP_IMG[vipCardLevel]}`} />
                    </div>
                    <div className="media-body">
                        <h4 className="media-heading">您目前是{VIP_NAME[vipCardLevel]}會員</h4>
                        <p>
                            指定管道儲值返利: <span style={{ color: '#e67a24' }}>{feedbackRate}</span>
                            <br />
                            啟用時間: {moment(startTime).format('YYYY/MM/DD')}
                            <br />
                            有效時間: {moment(endTime).format('YYYY/MM/DD')}
                            {vipCardLevel < 4 && <span><br />若期間有繼續升級，以升級後的卡別效期為準</span>}
                        </p>
                    </div>
                    {
                        vipCardLevel < 4 && <VipProgress userInfo={props.userInfo} />
                    }
                </div>
            </div>
        </div>
    );
}

function ActiveVip(props) {
    const { checkVipPreliminary, activeVip } = props;
    const { isBinding = false, profileValid = false, phoneValid = false, emailValid = false, checking } = props.userInfo;
    const list = [
        { check: isBinding, label: '帳號升級: 若您是透過 Facebook、Google 或其他帳號登入，請先完成升級程序', url: BINDING_URL },
        { check: profileValid, label: '資料完善: 填妥個人資料', url: PROFILE_URL },
        { check: phoneValid && emailValid, label: '完成手機號碼及email信箱驗證', url: PROFILE_URL },
    ];
    const btnEnable = isBinding && profileValid && phoneValid && emailValid;
    return (
        <div className="panel panel-default">
            <div className="panel-heading">啟用VIP</div>
            <div className="panel-body" style={{ position: 'relative' }}>
                {checking && <PanelLoading />}
                <h4>完成以下3步驟, 立即啟用VIP</h4>
                {
                    list.map((entry, i) => (
                        <h4 key={i} className={entry.check ? 'text-success' : 'text-danger'}>
                            {entry.check && <span className="glyphicon glyphicon-ok-sign"></span>}
                            {!entry.check && <span className="glyphicon glyphicon-remove-sign"></span>}
                            {` ${entry.label}`}
                            {!entry.check && <a href={entry.url} target="_blank">(點此完成)</a>}
                        </h4>
                    ))
                }
                <div className="btn-group">
                    <button
                        disabled={checking}
                        className={!checking ? 'btn btn-default' : 'btn btn-default disabled'}
                        onClick={() => !checking && checkVipPreliminary()}>
                        重新整理
                    </button>
                    <button
                        disabled={!btnEnable}
                        className={btnEnable ? 'btn btn-pubgame' : 'btn btn-pubgame disabled'}
                        onClick={() => btnEnable && activeVip()}>
                        啟用VIP
                    </button>
                </div>
            </div>
        </div >
    );
}

function Note() {
    return (
        <div className="panel panel-default">
            <div className="panel-heading">注意事項</div>
            <div className="panel-body">
                <ol style={{ lineHeight: '30px', paddingLeft: '16px' }}>
                    <li>2016VIP已於2017/08/31結束，2017/09/01起之VIP資格取得方式及回饋，均依新制VIP規範為準。</li>
                    <li>
                        於遊戲酒吧2017VIP活動贈獎取得之Pub點數，皆有使用期限，請於點數有效期限前兌換至遊戲內
                        <a style={{ color: '#00a0e9' }} href={PB_EXCHSNGE_GUIDE} target="_blank">《轉點教學》</a>
                        ，兌換入遊戲之遊戲幣使用時間不在此限。
                        且，活動贈獎取得之點數限會員本人使用，不可與他人進行現金與虛擬物品之買賣交易，
                        並不可要求兌現或改換其他商品。
                    </li>
                    <li>
                        本活動辦法及相關注意事項均載明於<Link style={{ color: '#00a0e9' }} to="/">VIP會員獨享權益</Link>活動網頁中，
                        於參加本活動之同時，即視為已詳閱並同意接受本活動辦法及相關注意事項之規範，
                        如有違反者，主辦單位保留法律追訴權。
                        本活動辦法若有未盡事宜，主辦單位保留增訂、變更、刪除或終止活動內容之權利，
                        修改訊息將公布於遊戲酒吧網站，不另行個別通知，請留意網站公告。
                        如遇不可抗力事由需變更回饋或贈獎內容，主辦單位有權變更為等值獎項，不得求兌現或轉換其他商品。
                    </li>
                </ol>
            </div>
        </div>
    )
}

function Profile(props) {
    const { internalId, pubpoints, orderAmount, vipStatus, vipCardLevel, loading } = props.userInfo;
    return (
        <div className="panel panel-default">
            <div className="panel-heading">會員資料</div>
            <div className="panel-body">
                <p className="text-center">
                    <img alt="avatar" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/noavatar_middle.gif" width="150px" height="150px" />
                </p>
            </div>
            <ul className="list-group">
                <li className="list-group-item">會員編號：{loading ? <Loading height="30px" width="30px" /> : <span>{internalId}</span>}</li>
                <li className="list-group-item">Pub點數：{loading ? <Loading height="30px" width="30px" /> : <span>{numbro(pubpoints).format('0,0')}</span>}</li>
                <li className="list-group-item">累計儲值金額：{loading ? <Loading height="30px" width="30px" /> : <span>{numbro(orderAmount).format('0,0')}</span>}</li>
                <li className="list-group-item">VIP卡別：{loading ? <Loading height="30px" width="30px" /> : <span>{vipStatus ? VIP_NAME[vipCardLevel] : '未啟用'}</span>}</li>
            </ul>
        </div>
    );
}

class Vip extends React.Component {
    componentDidMount() {
        if (this.props.isLogin) {
            this.props.fetchVipInfo();
        }
    }
    render() {
        if (!this.props.isLogin) {
            return <Redirect to={{ pathname: '/login', state: { from: '/vip' } }} />;
        }
        const { activeVip, userInfo, checkVipPreliminary } = this.props;
        return (
            <div className="container">
                <div className="page-header text-center">
                    <h1>我的VIP</h1>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <Profile userInfo={userInfo} />
                    </div>
                    <div className="col-md-9">
                        {userInfo.loading && <LoadUserInfo />}
                        {(!userInfo.loading && userInfo.vipStatus === 1) && <MyVip userInfo={userInfo} />}
                        {(!userInfo.loading && userInfo.vipStatus === 0) && <ActiveVip checkVipPreliminary={checkVipPreliminary} userInfo={userInfo} activeVip={activeVip} />}
                        <Note />
                    </div>
                </div>
            </div>
        );
    }
}

Vip.propTypes = {
    userInfo: PropTypes.shape({
        internalId: PropTypes.string,
        pubpoints: PropTypes.number, // Pub點數
        orderAmount: PropTypes.number,          // 至今累計儲值金額
        vipStatus: PropTypes.number, // vip狀態(未啟動/啟動)
        vipCardLevel: PropTypes.number,  // vip符合資格卡別
        startTime: PropTypes.string,     // vip起始時間
        endTime: PropTypes.string,       // vip有效時間
        isBinding: PropTypes.bool,      // 是否綁定Pubgame帳號
        profileValid: PropTypes.bool,   // 是否完善個人資料
        phoneValid: PropTypes.bool,     // 手機是否驗證過
        emailValid: PropTypes.bool,     // email是否驗證過
        loading: PropTypes.bool,
    }).isRequired,
    fetchVipInfo: PropTypes.func.isRequired,
    activeVip: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    userInfo: state.vip,
    isLogin: state.user.isLogin
});

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchVipInfo,
    activeVip,
    checkVipPreliminary
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Vip)



// WEBPACK FOOTER //
// ./src/containers/vip/index.jsx